if (!customElements.get('waite-quick-add')) {
  customElements.define('waite-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      if (!form) return;
      const button = form.querySelector('button[type="submit"]');
      const status = this.querySelector('[role="status"]');
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-open-options]');
      opener?.addEventListener('click', () => { status.textContent = ''; dialog.showModal(); });
      this.querySelector('[data-close-options]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog?.addEventListener('close', () => opener.focus());
      const select = form.querySelector('select[name="id"]');
      select?.addEventListener('change', () => {
        form.elements.quantity.value = select.selectedOptions[0].dataset.quantity || '1';
        status.textContent = '';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        this.busy = true;
        const label = button.textContent;
        const body = new FormData(form);
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.() || [];
        if (sections.length) body.set('sections', sections.map(section => section.section).join(','));
        body.set('sections_url', window.location.pathname);
        button.disabled = true;
        button.textContent = this.dataset.adding;
        this.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {method:'POST', headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}, body});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          status.textContent = this.dataset.added;
          dialog?.close();
          try {
            if (window.EliteCart?.openDrawerWithDataRefresh) {
              window.EliteCart.openDrawerWithDataRefresh();
            } else if (window.cartUpsell?.openCart) {
              window.cartUpsell.openCart();
            } else if (drawer?.renderContents && result.sections && sections.every(section => result.sections[section.section] && document.querySelector(section.id))) {
              drawer.setActiveElement?.(button);
              drawer.renderContents(result);
            } else {
              window.location.assign(`${root}cart`);
            }
          } catch {
            window.location.assign(`${root}cart`);
          }
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
        } finally {
          this.busy = false;
          button.disabled = false;
          button.textContent = label;
          this.removeAttribute('aria-busy');
        }
      });
    }
  });
}
